import ReactGa from "react-ga";

export const GA_REACT = {
  CATEGORY: {
    USER: "USER",
  },
  ACTION: {
    MOBILE: {
      OPEN: "OPEN_ON_MOBILE",
      DOWNLOAD_RESUME: "DOWNLOAD_RESUME_MOBILE",
    },
    DESKTOP: {
      OPEN: "OPEN_ON_NOT_MOBILE",
      DOWNLOAD_RESUME: "DOWNLOAD_RESUME_NOT_MOBILE",
    },
  },
  initialize(trackingID = "UA-165377946-1") {
    ReactGa.initialize(trackingID);
  },
  storePageView() {
    ReactGa.pageview(`${window.location.pathname}${window.location.search}`);
  },
  createEvent(action, options = {}, category = "USER") {
    ReactGa.event({
      category,
      action,
      ...options,
    });
  },
};
